export default __webpack_public_path__ + "6fb9bb4ce00e708bd15436748395d7ed.svg";